import * as React from 'react';
import { FunctionalButton, Link } from "./styles";


/**
 * Button
 *
 * This component allows to use `href` and `onClick` props on the same component.
 * It is useful, since `Action` component could have a link to some resources.
 *
 * This component exists because `window.open` call has
 * a vulnerability as a link without `ref="noopener noreferer"`
 * and very few browsers support `noopener` feature for `window.open` call.
 *
 * The `a` node renders if `href` prop was passed.
 * The `button` will be rendered if `onClick` or `disabled` props were passed.
 *
 * @param {ButtonProps} {
 *     className, children, onClick, href, disabled,
 * }
 * @returns {JSX.Element}
 */
export const Container = ({
  className,
  children,
  onClick,
  href,
  disabled,
  target,
  testId = 'default' }) =>
{
  if (disabled || !href) {
    return /*#__PURE__*/(
      React.createElement(FunctionalButton, {

        className: className,
        disabled: disabled,
        onClick: onClick },

      children));


  }

  return /*#__PURE__*/(
    React.createElement(Link, {

      className: className,
      onClick: onClick,
      href: href,
      target: target },

    children));


};